import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import IconButton from '../../common/IconButton';
import {
  Dialog as MUIDialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './styles/dialog.scss';

const Dialog = forwardRef((props, ref) => {
  const {
    isOpen = false,
    onClose,
    titleIcon,
    renderTitle,
    className = '',
    titleClassName = '',
    contentClassName = '',
    actionsClassName = '',
    contentSubTitleClassName = '',
    renderActions,
    renderContent,
    renderContentSubTitle,
    dialogContentProps,
    fullScreen,
    showCloseIconInTitle = true,
    ...dialogProps
  } = props || {};
  return (
    <MUIDialog
      ref={ref}
      className={`dialog ${fullScreen ? 'dialog--full-screen' : ''} ${className || ''}`}
      open={isOpen}
      aria-labelledby='dialog-title'
      aria-describedby='dialog-content'
      fullScreen={fullScreen}
      closeAfterTransition={true}
      disableRestoreFocus={true}
      slotProps={{ backdrop: { className: 'dialog__backdrop' } }}
      {...(dialogProps || {})}
    >
      {renderTitle && (
        <DialogTitle
          id='dialog-title'
          className={`dialog__title${renderContent ? '' : ' dialog__title--no-content'} ${titleClassName || ''}`}
        >
          {titleIcon && titleIcon}
          {renderTitle()}
          {showCloseIconInTitle && !!onClose && (
            <IconButton
              className='dialog__title__close-button'
              aria-label='close'
              onClick={onClose}
              variant='tonalV2'
            >
              <CloseIcon />
            </IconButton>
          )}
        </DialogTitle>
      )}
      {renderContent && (
        <DialogContent
          id='dialog-content'
          className={`dialog__content ${contentClassName || ''}`}
          {...(dialogContentProps || {})}
        >
          {renderContentSubTitle && (
            <div
              className={`dialog__content__subtitle ${contentSubTitleClassName || ''}`}
            >
              {renderContentSubTitle()}
            </div>
          )}
          <div
            className={`dialog__content__text ${contentClassName ? contentClassName + '__text' : ''}`}
          >
            {renderContent()}
          </div>
        </DialogContent>
      )}
      {renderActions && (
        <DialogActions className={`dialog__actions ${actionsClassName || ''}`}>
          {renderActions()}
        </DialogActions>
      )}
    </MUIDialog>
  );
});

Dialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  fullScreen: PropTypes.bool,
  location: PropTypes.object,
  account: PropTypes.object,
  unsavedChangesInstance: PropTypes.object,
  isNavigationMenuOpen: PropTypes.bool,
  setIsNavigationMenuOpen: PropTypes.func,
  renderActions: PropTypes.func,
  renderContent: PropTypes.func,
  titleIcon: PropTypes.node,
  renderTitle: PropTypes.func,
  renderContentSubTitle: PropTypes.func,
  titleClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  actionsClassName: PropTypes.string,
  contentSubTitleClassName: PropTypes.string,
  className: PropTypes.string,
  showCloseIconInTitle: PropTypes.bool,
  dialogContentProps: PropTypes.object
};

export default Dialog;
